import styled from '@emotion/styled'

export const ShiftDetailsUIStyles = styled.div`
   .pageHeader{
    background-color: #EBEBEB;
    display: flex;                
    flex-direction: row;           
    flex-wrap: nowrap;            
    justify-content: space-between; 
    padding:17px 74px 8px 91px;
    font-size:20px;
    .shiftTitle {
      font-weight:bold !important;
      text-align:center;
    }
    .shiftTime{
      font-size:15px !important;
      font-weight:normal !important;
    }
   }
   .userlist{
    padding-top:30px;
   }
  .shiftDetailBodyContainer{
    margin-left:37px;
    margin-right:37px;
   .notes{
    background: #FFFFFF;
    box-shadow: 0px 3px 6px #00000029;
    padding-top:15px;
    padding-bottom: 2px;
    padding-left:16px;
    margin-top:30px;
    margin-bottom:30px;
    ul{
      padding-left:15px !important;
    }
    li{
      font-size:17px;
      padding-bottom:15px;
    }
    .notesForMNGR{
      margin-top:25px;
      margin-bottom:37px;
      width:95%;
    }
  }
   .endShiftButton{
    background-color: #21C769 !important;
    color: #000000;
    padding:13px 68px;
    margin-bottom:203px;
    border-radius: 9px;
    font-weight:bold;
    font-size:24px;
    text-transform:none !important;
    } 
  }
   
  `;

export const ChecklistUIStyle= styled.div`
  .checklist{
    background: #EBEBEB;
    display:flex;
    flex-direction: row;           
    flex-wrap: nowrap;            
    justify-content: space-between; 
    margin-bottom:10px;
    .name{
    font-weight:bold;
    font-size:20px;
    padding-top:17px;
    padding-bottom:17px;
    padding-left:11px;
    }
    .cheklistRightSection{
      img{
        padding-right:33px;
        padding-top:20px;
        padding-bottom:18px;
      }
      .expand{
        margin-bottom:5px;
      }
    }
    
  }
  .chklistitemsContainer{
    box-shadow: 0px 3px 6px #00000029;
    margin-bottom:30px;
    padding-bottom:28px;
  }
  `;
export const EmpRatingsUIWrapper=styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  flex-flow: column;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  text-align:center;
  .ratingsContainer{
    box-shadow: 0px 4px 12px #00000029;
    border-radius: 12px;
    padding:100px 113px 35px 113px;
    margin-bottom:50px;
    margin-top:50px;
  }
  .greetingHeader{
    color: #1DB45D;
    font-size:24px;
    font-weight:bold;
    padding-top:21px;
    padding-bottom:15px;
  }
  .ratingCount{
    color: #1DB45D;
    padding-bottom:25px;
  }
  .ratingNotes{
    padding-bottom:61px;
  }
  .done{
    cursor:pointer;
  }
`;  